import { Box, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { Helmet } from 'react-helmet-async';

import FormStyle from '../FormStyle';

function ChangedPasswordWithSuccess(
  {
    setIsEditing,
    setChangedPasswordSucessfully,
  }: {
    setIsEditing: (isEditing: boolean) => void,
    setChangedPasswordSucessfully: (changedPasswordSucessfully: boolean) => void,
  },
) {
  const handleReturn = () => {
    setIsEditing(false);
    setChangedPasswordSucessfully(false);
  };

  return (
    <div className="main">
      <Helmet>
        <title>Change password</title>
      </Helmet>
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <Box className="container-fluid">
          <Box sx={FormStyle.previewHeader}>
            <h1 className="text-bold">Change password</h1>
          </Box>
          <Box className="card">
            <Box className="card-body">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h3>Password change completed.</h3>
                <FontAwesomeIcon
                  size="8x"
                  color="rgb(28, 187, 140)"
                  icon={faCircleCheck}
                  className="my-5"
                />
                <Button
                  onClick={handleReturn}
                  variant="outlined"
                  className="btn-outline-secondary"
                >
                  Back
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default ChangedPasswordWithSuccess;
